export default __webpack_public_path__ + "static/media/Lovrican-Drawer.2a3230f7.svg";